import { AnalyticsTypes } from '../../middleware/google-analytics';

export const ActionTypes = {
    TRACK_PREVIOUS_MONOLITH_ACTION: '@@previousActions/TRACK_PREVIOUS_MONOLITH_ACTION',
};

export const trackPreviousMonolithAction = ({
    action,
    category,
    label,
    pageId,
}) => ({
    type: ActionTypes.TRACK_PREVIOUS_MONOLITH_ACTION,
    meta: {
        analytics: {
            action,
            type: AnalyticsTypes.TrackPreviousMonolithEvent,
            category,
            label,
            pageId,
        },
    },
});
